import React, {useRef, useState} from "react";
import {Loader} from "@/customComponents/uiComponents/Loader.jsx";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";

export function SpecialRequest({setStep, closeModal, previousStep}) {
    const isEdit = storage.get(STORAGE_KEYS.EDIT_STEP) === true;
    const [textRequest, setTextRequest] = useState(storage.get(STORAGE_KEYS.SPECIAL_REQUEST, ""));
    const [caringPet, setCaringPet] = useState(storage.get(STORAGE_KEYS.CARING_PET, false));
    const [quietRide, setQuietRide] = useState(storage.get(STORAGE_KEYS.QUIET_RIDE, false));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const originalRef = useRef({
        text: storage.get(STORAGE_KEYS.SPECIAL_REQUEST, ""),
        caringPet: storage.get(STORAGE_KEYS.CARING_PET, false),
        quietRide: storage.get(STORAGE_KEYS.QUIET_RIDE, false),
    });

    const handleTextChange = (e) => {
        const value = e.target.value;
        setTextRequest(value);
        storage.set(STORAGE_KEYS.SPECIAL_REQUEST, value);
        if (value.trim()) setError("");
    };

    const handleDoneClick = () => {
        if (!textRequest.trim()) {
            setError("Please enter your instruction");
            return;
        }
        setError("");

        if (isEdit) {
            const orig = originalRef.current;
            const unchanged = textRequest === orig.text && caringPet === orig.caringPet && quietRide === orig.quietRide;
            if (unchanged) {
                setStep('orderDetails');
                return;
            }
        }

        setLoading(true);
        storage.set(STORAGE_KEYS.CAR_SPECIAL_REQUEST, true);
        setTimeout(() => {
            if (isEdit) {
                storage.set('hopnSpecialRequestSavedNotice', true);
                setStep('orderDetails');
            } else if (previousStep) {
                setStep(previousStep);
            }
        }, 800);
    };

    const handleCheckbox = (setter, key) => (e) => {
        setter(e.target.checked);
        storage.set(key, e.target.checked);
    };

    const handleCancel = () => {
        if (isEdit) {
            setStep('orderDetails');
            return;
        }
        setTextRequest('');
        setCaringPet(false);
        setQuietRide(false);
        setError('');
        storage.remove(STORAGE_KEYS.SPECIAL_REQUEST);
        storage.set(STORAGE_KEYS.CARING_PET, false);
        storage.set(STORAGE_KEYS.QUIET_RIDE, false);
        storage.set(STORAGE_KEYS.CAR_SPECIAL_REQUEST, false);
        if (previousStep) setStep(previousStep);
    };

    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={isEdit ? null : previousStep} showBackButton={!isEdit} enableEditModeOnBackButton={false} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                <div className="hopn-spacial-request">
                    <p>Let driver know more about your requests</p>
                    <div className="spaial-request-btn">
                        <div className="request-option">
                            <input type="checkbox" id="caring-pet" checked={caringPet} onChange={handleCheckbox(setCaringPet, STORAGE_KEYS.CARING_PET)}/>
                            <label htmlFor="caring-pet"><h6>Caring pet?</h6></label>
                        </div>
                        <div className="request-option">
                            <input type="checkbox" id="quiet-ride" checked={quietRide} onChange={handleCheckbox(setQuietRide, STORAGE_KEYS.QUIET_RIDE)}/>
                            <label htmlFor="quiet-ride"><h6>Quiet Ride</h6></label>
                        </div>
                    </div>
                    <h6>Enter any instruction</h6>
                    <textarea name="detail-request" onChange={handleTextChange} value={textRequest}/>
                    {error && <p className="hopn-error-text">{error}</p>}
                    <button className="hopn-add-passenger-button" onClick={handleDoneClick} disabled={loading}>
                        {loading ? <Loader color="#fff"/> : "Done"}
                    </button>
                    <br/>
                    <button
                        className="hopn-add-passenger-button transparent no-icon"
                        onClick={handleCancel}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </>
    );
}
export default SpecialRequest;
